var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('div',{staticClass:"md-layout-item md-size-100 mx-auto"},[_c('ProductivityTable',{on:{"updateResponse":function($event){_vm.dataTable = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }